import { Box, Typography } from '@mui/material';
import { radius } from '@karehero/llama/theme/radius';

import type { Tone } from '@/benefits-flow/tones';

// A small rounded tone label, used for eligibility and action states across the
// cards, variants and scenario table. One component so the tone tokens live in
// a single place (tones.ts) rather than being re-inlined per surface.
export type PillProps = {
  label: string;
  tone: Tone;
};

const Pill = ({ label, tone }: PillProps) => (
  <Box
    sx={{
      px: 1,
      py: 0.25,
      borderRadius: `${radius.xxl}px`,
      bgcolor: tone.bg,
      border: tone.border ? 1 : 0,
      borderColor: tone.border,
      flexShrink: 0,
    }}
  >
    <Typography variant='caption' color={tone.color} noWrap>
      {label}
    </Typography>
  </Box>
);

Pill.displayName = 'Pill';
export default Pill;
